import React from 'react';
import { Typography } from '../../../../components';

const ClicksConversionTab: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-[25rem]">
      <Typography variant="body1" className="text-zinc-500">
        Таб "Клики / Конверсия" в разработке
      </Typography>
    </div>
  );
};

export default ClicksConversionTab;
